export default {
  en: {
    INPUT_MIN_MAX: {
      LABEL: 'Enter Range',
      PLACEHOLDER_MIN: 'Min',
      PLACEHOLDER_MAX: 'Max',
    },
    INPUT_TEXT: {
      LABEL: 'Enter Value',
      PLACEHOLDER: 'Value'
    },
    INPUT_PHONE_NUMBER: {
      VALID: 'The phone number is valid',
      INVALID: 'The phone number is invalid',
      VALIDATE_FAILURE: 'Operation to validate failed'
    }
  }
};